export default "__VITE_ASSET__BFap1Jyi__"